/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import {useState} from 'react'
import {Modal, Tab, Tabs} from 'react-bootstrap'
import {KTSVG, toAbsoluteUrl} from '../../../../../_metronic/helpers'
import UseTemplateName from './UseTemplateName'

interface modalTypes {
  show: any
  handleClose: () => void
  data: any
  setdata: any
}

const TemplatePreviewModal = ({setdata, data, show, handleClose}: modalTypes) => {
  const [campnanme, setCampName] = useState({
    name: '',
    subTitle: '',
  })

  const [open, setOpen] = useState(false)

  return (
    <>
      <UseTemplateName
        close={handleClose}
        show={open}
        campName={campnanme}
        setCampName={setCampName}
        setOpen={() => setOpen(false)}
        userData={show}
        setdata={setdata}
        data={data}
      />
      <Modal
        id='kt_modal_create_app'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-700px h-auto'
        show={show?.open}
        onHide={handleClose}
      >
        <div className=''>
          <div className='modal-header'>
            <h2>Preview</h2>
            <div className='btn btn-icon btn-sm' onClick={handleClose}>
              <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
            </div>
          </div>
          <div className='modal-body'>
            <div className='row d-flex justify-content-between flex-wrap preview-modal'>
              <div className='col-12 col-xl-6 col-lg-6 d-flex col-sm-12'>
                <div
                  className='mobile-bg-wrapper'
                  style={{
                    backgroundImage: `url(${toAbsoluteUrl('/media/mobile/NewMobile.png')})`,
                  }}
                >
                  <div className='inner-content-main'>
                    {show?.data?.type == 'MMS' && (
                      <>
                        {/* { ( show?.data?.subjectTitle !== "") ?<div className='messageStyle'> <span>{show?.data?.subjectTitle}</span> </div>:<div className='messageStyle'> <span>{"Engaging Subject title here"}</span></div>} */}

                        <span>
                          <img src={show?.data?.media} alt='poster' />
                        </span>
                      </>
                    )}

                    {show?.data?.message !== '' ? (
                      <div className='messageStyle'>
                        {' '}
                        <span>{show?.data?.message}</span>{' '}
                      </div>
                    ) : (
                      <>
                        {' '}
                        <span></span>
                      </>
                    )}
                  </div>
                  {/* <div className='wrapper-tabs'>
                  <Tabs
                    defaultActiveKey='notification'
                    className='nav nav-tabs nav-pills border rounded p-2 fs-6 text-dark d-flex justify-content-between'
                  >
                    <Tab eventKey='notification' title='Notification' />
                    <Tab eventKey='message' title='Message' />
                  </Tabs>
                </div> */}
                </div>
              </div>
              <div className='col-12 col-xl-6 col-lg-6 mt-3 col-sm-12'>
                <div className=' mt-3'>
                  <img
                    alt='Logo'
                    src={show?.data?.media}
                    className='w-100 mw-150px border-10 rounded'
                  />
                </div>
                <div className='mt-3 d-flex flex-row flex-wrap'>
                  <a className={'badge badge-light-success me-2'}>{show?.type}</a>
                  {show?.tags?.map((tags: any, i: number) => {
                    return (
                      <a key={i} className={'badge badge-light-primary me-2 mb-2'}>
                        {tags}
                      </a>
                    )
                  })}
                </div>
                <div className='mt-3 w-100 mw-250px'>
                  <p className='previewModal_desc'>{show?.data?.message}</p>
                </div>
                <div className='pre-total'>
                  <img
                    src={toAbsoluteUrl('/media/mobile/calandar.svg')}
                    alt='preview'
                    className='me-1'
                  />
                  {show?.data?.message?.split('')?.length}
                </div>
                <div className='mt-5'>
                  <button
                    className='btn btn-sm btn-light btn-primary me-2 w-100 mw-150px p-3 fw-500'
                    onClick={() => setOpen(true)}
                  >
                    Use the Template
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default TemplatePreviewModal
